import { Address, PublicClient } from 'viem';

import { LIQUID_STAKING_TOKEN_ADDRESS } from 'modules/api/const';
import { getLiquidStakingTokenContract } from 'modules/api/contracts/getLiquidStakingTokenContract';
import { convertFromWei } from 'modules/api/utils';
import { HUNDRED } from 'modules/common/const';
import { getLiquidStakingPoolAddress } from 'modules/liquidStaking/methods/getLiquidStakingAddress';
import { ILiquidStakingPool } from 'modules/liquidStaking/types';

export async function getLiquidStakingToken(
  client: PublicClient,
  poolAddress: Address = LIQUID_STAKING_TOKEN_ADDRESS,
): Promise<ILiquidStakingPool> {
  const contract = getLiquidStakingTokenContract(client, poolAddress);

  const [feeWei, totalSupplyWei] = await Promise.all([
    contract.read.lspFee(),
    contract.read.totalSupply(),
  ]);

  const fee = convertFromWei(feeWei, 2);

  return {
    address: LIQUID_STAKING_TOKEN_ADDRESS,
    poolAddress: await getLiquidStakingPoolAddress(client),
    fee: fee.div(HUNDRED),
    totalAmount: convertFromWei(totalSupplyWei),
  };
}
